import React, {ClassAttributes, InputHTMLAttributes} from 'react';
import {MultiCombobox, Option} from "../Control";
import {FieldHookConfig, useField} from "formik";
import FieldHelp from "./FieldHelp";

// Component ----

type CustomProps = {
  options: Array<Option>
  label?: string
  hint?: string
  help?: string
  onSearch?: (searchTerm?: string) => void,
  isLoading?: boolean
  max?: number
}

export type MultiSelectFieldProps = InputHTMLAttributes<HTMLInputElement>
  & ClassAttributes<HTMLSelectElement>
  & FieldHookConfig<string>
  & CustomProps

function MultiSelectField({options, label, hint, help, onSearch, isLoading, max, ...props}: MultiSelectFieldProps) {
  const [field, meta, {setValue}] = useField<Array<string>>(props.name)

  const handleChange = (options: Array<Option>) => {
    if(max && options.length > max) return;

    void setValue(options.map(option => option.id?.toString() as string))
  }
  // Error state
  const hasError = meta.touched && !!meta.error

  // Preselected options
  const selectedOptions = (field.value ?? [])
    .map(value => options.find(option => option.id?.toString() === value.toString()))
    .filter(Boolean) as Option[]

  return (
    <div>
      <MultiCombobox
        label={label}
        hint={hint}
        options={options}
        selected={selectedOptions}
        onSearch={onSearch}
        onChange={handleChange}
        isLoading={isLoading}
      />

      {/* Help text or error message */}
      {(!!help || hasError) &&
        <FieldHelp isError={hasError}>
          {hasError ? meta.error : help}
        </FieldHelp>
      }
    </div>
  );
}

export default MultiSelectField;